// tilePicker (pure) — the add/remove logic and palette ordering behind the visual <TilePicker>.
// Kept JSX-free and dependency-light so it is unit-testable in the plain-Node test runtime (the DOM
// component in TilePicker.tsx is a thin presentational wrapper over these helpers).
import type { TileId } from '@mj/protocol';

/**
 * The clickable palette: the 34 standard tiles in canonical order (man 1-9, pin 1-9, sou 1-9,
 * honors z1-z7) plus the 3 aka fives. No `back`, no z8/z9 — those are not hand-composable faces.
 */
export const PALETTE_TILES: readonly TileId[] = [
  'm1', 'm2', 'm3', 'm4', 'm5', 'm5r', 'm6', 'm7', 'm8', 'm9',
  'p1', 'p2', 'p3', 'p4', 'p5', 'p5r', 'p6', 'p7', 'p8', 'p9',
  's1', 's2', 's3', 's4', 's5', 's5r', 's6', 's7', 's8', 's9',
  'z1', 'z2', 'z3', 'z4', 'z5', 'z6', 'z7',
];

/**
 * Append `tile` to the picked list (immutably). Duplicates are allowed (up to four of a kind is a
 * legal hand). When `max` is given and the list is already at capacity, returns the list unchanged.
 */
export function addTile(current: readonly TileId[], tile: TileId, max?: number): TileId[] {
  if (max !== undefined && current.length >= max) return current as TileId[];
  return [...current, tile];
}

/** Remove exactly the picked tile at `index` (immutably). Out-of-range indices are a no-op copy. */
export function removeAt(current: readonly TileId[], index: number): TileId[] {
  if (index < 0 || index >= current.length) return current as TileId[];
  return current.filter((_, i) => i !== index);
}
